var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatisticIconNotFinalized(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M19.5 0C30.2696 0 39 8.73045 39 19.5C39 30.2696 30.2696 39 19.5 39C8.73045 39 0 30.2696 0 19.5C0 8.73045 8.73045 0 19.5 0Z",
    fill: "#8F8ECA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 24.3262C9.75 20.5393 13.8494 18.1725 17.129 20.0659L18.1353 20.647C18.2902 20.7364 18.4167 20.8862 18.4167 21.0651V23.657C18.4167 26.5248 15.2968 28.3037 12.8288 26.8431L10.348 25.375C9.97736 25.1557 9.75 24.7569 9.75 24.3262ZMnan nanL29.25 15.677V24.3262C29.25 24.7569 29.0226 25.1557 28.6519 25.375L26.6099 26.5835C23.9481 28.1587 20.5833 26.2401 20.5833 23.1472V20.7448C20.5833 20.7041 20.6065 20.6673 20.6417 20.647L29.25 15.677Lnan nanZ",
    fill: "#615CFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.499209,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.448 13.7066C10.2191 13.5745 10.1628 13.2612 10.3961 13.1369L18.9273 8.59302C19.2855 8.40226 19.7151 8.40226 20.0732 8.59302L28.6045 13.1369C28.7787 13.2298 28.7474 13.4654 28.5764 13.5642L19.5587 18.7705C19.4549 18.8304 19.3227 18.8304 19.2189 18.7705L10.448 13.7066Z",
    fill: "#615CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatisticIconNotFinalized);
export default __webpack_public_path__ + "static/media/statistic_icon_not_finalized.2005bebc232debb525e504f75fe6d566.svg";
export { ForwardRef as ReactComponent };